<template>
  <div class="confirm">
    <Flow v-bind:step="5"/>
    <div class="bg_white mt12 pt16 pb16 boxs1 pl15 pr15">
      <h1 class="complete_text ab">注文が完了しました。</h1>

      <div v-if="errorList.length > 0" class="mt12">
        <p class="error_text ab" v-html="message">{{message}}</p>
        <p class="errorBc_text ab">失敗したBC</p>
        <ul class="errorBc_list">
          <li class="errorBc_list--item ab" v-for="val in errorList">BC{{ val.productName + ': ' + val.errorMessage }}</li>
        </ul>
      </div>

      <router-link :to="{ name: 'NSelectionSelectProducts' }" v-on:click.native="clearData()" class="complete_btn btn btn_blue">商品選択に戻る</router-link>
    </div>
    <ConfirmProductsList :edit="false" />

    <div class="confirm_credit bg_white mt12 pt16 pb16 boxs1">
      <h2 class="content_title rb">お支払い情報</h2>
      <div class="confirm_wrap pl16 pr25 bdb">
        <div class="">
          <p class="confirm_data rb">{{ detailData.paymentData.paymentMethodName }}</p>
          <p class="data_contents" v-if="detailData.paymentData.paymentMethod == 'CREDIT_CARD'">{{ detailData.creditData.cardNo }}</p>
        </div>
      </div>
    </div>

    <div class="sum_total bg_white mt12 pt16 pb16">
      <h2 class="content_title sum">合計</h2>
      <AmountList />
    </div>

  </div>
</template>

<script>
import { mapGetters } from 'vuex';
import Flow from '@/components/n-selection/Flow';
import Config from '@/config/config'
import ConfirmProductsList from '@/components/n-selection/ConfirmProductsList';
import AmountList from '@/components/n-selection/AmountList';


export default {
  props: ['message', 'errorList'],
  components: {
    Flow,
    ConfirmProductsList,
    AmountList
  },
  methods: {
    clearData() {
      localStorage.removeItem('deliveryTimeData');
      localStorage.removeItem('nselectionOrderList');
      localStorage.removeItem('creditData');

      this.$store.commit('nselection/setCartCount', 0);
      this.$store.dispatch('nselection/calcTotalPoint', { point: 0, reset: true });
      this.$store.commit('nselection/setWalletAmount', 0);
      this.$store.commit('nselection/setShipmentFee', 0);
      this.$store.commit('nselection/setUseWalletBillAmount', 0);
      this.$store.commit('nselection/setUseWallet', 0);
      this.$store.commit('nselection/setUsePurchasePoint', 0);
      this.$store.commit('nselection/setPaymentMethod', '');
      this.$store.commit('nselection/setPaymentMethodName', '');
      this.$store.commit('nselection/setCartIsDisabled', true);
      this.$store.dispatch('nselection/initializedProductsList');
      this.$store.dispatch('nselection/resetRequestData');
      this.$store.commit('nselection/setSelectWalletType', 'NO_USE');
      this.$store.commit('nselection/setInputWallet', 0);

    },
  },
  computed: mapGetters(
    'nselection', [
      'requestData',
      'detailData',
      'confirmShipmentFee'
    ]
  ),
};
</script>

<style lang="css" scoped>
.complete_text {
  font-size: 18px;
  text-align: center;
}
.error_text {
  color: #ff0000;
  font-size: 16px;
  text-align: center;
}
.errorBc_text {
  margin-top: 5px;
}
.errorBc_list {
  margin-top: 5px;
}

.errorBc_list--item {
  font-size: 17px;
  margin-top: 4px;
}

.complete_btn {
  margin-top: 30px;
}
.content_title {
  width: 140px;
}
.content_title.sum {
  width: 120px;
}



.confirm_wrap {
  align-items: flex-end;
  /* border-bottom: 1px solid #C9C9C9; */
  display: flex;
  justify-content: space-between;
  margin-top: 20px;
  padding-bottom: 8px;
}
.edit {
  letter-spacing: 7.5px;
  margin: 0;
  text-indent: 7.5px;
}
.confirm_data {
  color: #5a5a5a;
  font-size: 16px;
  line-height: 1;
}
.data_wrap {
  margin-top: 14px;
}
.data_contents {
  font-size: 14px;
  line-height: 1;
  margin-top: 10px;
}
.coupon_text {
  font-size: 12px;
  line-height: 1;
}
.count {
  font-size: 20px;
  margin-left: 25px;
}
.confirm_coupon .edit {
  margin: 16px 0 0 auto;
}
.confirm_address .confirm_wrap {
  margin-top: 27px;
}
.confirm_credit .confirm_wrap {
  margin-top: 24px;
}
.confirm_coupon .confirm_wrap {
  margin-top: 30px;
}

.sum_total {
  padding-bottom: 48px;
}

.complete {
  margin-top: 56px;
}
</style>



// WEBPACK FOOTER //
// src/views/n-selection/Complete.vue